import _lib from '../_lib';
import active from './active/index';
import {CurrentDiagNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'currentdiag';
  let activations = [
    {
      name: 'currentdiag',
      test: api.messageIs(CurrentDiagNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};